window.addEventListener('load', function () {
	function handleMessage(event) {

		if (event.origin !== "https://uk.changegroup.com/") {

			return;

		}

		const data = event.data;

		const extraHeight = 20;

		if (data.type === "tmo3pw") {

			const iframe = document.getElementById('cg3paiframe');

			iframe.style.height = `${data.newHeight + extraHeight}px`;

		}

	}

	window.addEventListener("message", handleMessage, false);
	
});